(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/bank-card/bank-card.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/bank-card/bank-card.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  logger
} = svs.accountservicesReact.deposit.bankCard;
const {
  BANKCARD
} = svs.accountservicesReact.deposit.constants.paymentTypes;
const {
  Form
} = svs.ui.reactForm;
const {
  useEffect,
  useState
} = React;
const {
  paymentTypes
} = svs.accountservicesReact.deposit.constants;

const {
  showDepositError,
  showDepositSuccess
} = svs.accountservicesReact.deposit.dialogs.sharedDialogs;
const {
  CurrencyAsJupiterString: formatCurrencyAsJupiterString
} = svs.utils.format;
const {
  getErrorCode,
  updateBalanceAsync,
  removeUrlAfterPayServerAsync
} = svs.accountservicesReact.deposit.helpers.sharedHelpers;
const {
  trackSuccess,
  trackFailure
} = svs.accountservicesReact.deposit.tracking.sharedTracking;
const {
  clearFormsDataAction,
  amountChangeAction
} = svs.accountservicesReact.deposit.store.deposit.actions;
const {
  instantPayClear
} = svs.accountservicesReact.deposit.store.deposit.actions;
const {
  SWEDBANKPAY_CONTAINER_ELEMENT
} = svs.accountservicesReact.deposit.constants;
const {
  OnboardingDepositAmountInfo,
  DepositButton,
  DepositInput
} = svs.accountservicesReact.deposit.depositShared;
const BANKCARD_STATE = {
  INIT: 0,
  POLL: 1
};
const KYC_ERROR = 100020;
let swedbankPayCheckout;
const formatAndDeposit = amount => {
  const transAmount = formatCurrencyAsJupiterString(amount);
  swedbankPayCheckout.deposit(transAmount, BANKCARD);
};
const baseOptions = {
  el: SWEDBANKPAY_CONTAINER_ELEMENT,
  errorFn: (err, transactionData) => {
    const errorCode = getErrorCode(err);
    logger.debug(err, transactionData);
    trackFailure(BANKCARD, errorCode);
    if (errorCode === KYC_ERROR) {
      svs.core.module.load('/cl/components/kyc-messages', null, () => {
        svs.components.kyc_messages.showKYCMessage();
      });
    } else if (errorCode === 100037 || errorCode === 10) {
      location.reload();
    } else {
      showDepositError(err, transactionData);
    }
  },
  backButton: true,
  backButtonText: 'Tillbaka',
  backButtonCallback: () => {
    svs.components.analytics.trackEvent({
      category: 'Deposits',
      action: 'Deposit Cancel BackButton',
      opt_label: 'CC'
    });
  },
  prefixText: 'Betalningar',
  isNotInfoText: false,
  context: void 0
};
const BankCard = _ref => {
  let {
    isPlayerRegistration,
    returnUrl,
    swedbankPayProps
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const depositAmount = ReactRedux.useSelector(state => state.deposit.amount);
  const instantPay = ReactRedux.useSelector(state => state.deposit.instantPay);
  const [apState, setApState] = useState(BANKCARD_STATE.INIT);
  useEffect(() => {
    const {
      hasInstantPayAmount
    } = svs.accountservicesReact.deposit.helpers.sharedHelpers;
    const prepareFn = () => setApState(BANKCARD_STATE.POLL);
    const cleanUpFn = () => {
      setApState(BANKCARD_STATE.INIT);
      window.scrollTo(0, 0);
    };
    const successFn = async successEventData => {
      if ((returnUrl === null || returnUrl === void 0 ? void 0 : returnUrl.length) > 0) {
        await removeUrlAfterPayServerAsync();
      }
      await trackSuccess(successEventData === null || successEventData === void 0 ? void 0 : successEventData.paymentType, successEventData === null || successEventData === void 0 ? void 0 : successEventData.amount);
      logger.debug('payment success!', successEventData);
      dispatch(clearFormsDataAction());
      dispatch(instantPayClear());
      setApState(BANKCARD_STATE.INIT);
      successEventData.accountBalance = await updateBalanceAsync(successEventData.accountBalance);
      await showDepositSuccess({
        amount: successEventData.amount,
        accountBalance: successEventData.accountBalance,
        paymentType: paymentTypes.BANKCARD
      }, returnUrl);
    };
    const options = _objectSpread(_objectSpread({}, baseOptions), {}, {
      prepareFn,
      cleanUpFn,
      successFn
    });
    if ((swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.hasBackButton) !== undefined) {
      options.backButton = swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.hasBackButton;
    }
    if (typeof (swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.backButtonText) === 'string' && (swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.backButtonText.length) > 0) {
      options.backButtonText = swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.backButtonText;
    }
    swedbankPayCheckout = new svs.accountservices.swedbankpay_checkout.SwedbankPayCheckout(options);
    if (instantPay !== null && instantPay !== void 0 && instantPay.isPay) {
      formatAndDeposit(instantPay.amount);
    } else if (hasInstantPayAmount(instantPay)) {
      dispatch(amountChangeAction(instantPay === null || instantPay === void 0 ? void 0 : instantPay.amount));
    }
  }, [dispatch, instantPay, returnUrl, swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.backButtonText, swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.hasBackButton]);
  const handleSubmit = (e, isValid) => {
    e.preventDefault();
    if (!isValid) {
      return;
    }
    formatAndDeposit(depositAmount);
  };
  return React.createElement("div", null, React.createElement(Form, {
    method: "post",
    onSubmit: (e, _formData, isValid) => {
      handleSubmit(e, isValid);
    }
  }, apState === BANKCARD_STATE.INIT && React.createElement(React.Fragment, null, React.createElement(DepositInput, null), isPlayerRegistration && React.createElement(OnboardingDepositAmountInfo, {
    depositAmount: depositAmount
  }), React.createElement(DepositButton, null)), React.createElement("div", {
    className: SWEDBANKPAY_CONTAINER_ELEMENT
  })));
};
svs.accountservicesReact.deposit.bankCard.BankCard = BankCard;

 })(window);